<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini">新建</el-button>
    <el-dialog
      title="新建"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="lang">
          <el-checkbox-group v-model="form.lang">
            <el-checkbox
              v-for="(item, index) in langArr"
              :label="item.labal"
              :key="index"
              >{{ item.value }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item
          :label-width="formLabelWidth"
          prop="userId"
          v-for="(item, index) in form.lang"
          :key="index"
          :label="`${FINDLANGARR(item)}名称`"
        >
          <el-input v-model="form[item]" class="searchIpt"></el-input>
        </el-form-item>

        <el-form-item
          v-for="(item, index) in form.lang"
          :key="index"
          :label="`${FINDLANGARR(item)}任务说明`"
          :label-width="formLabelWidth"
          prop="inviteBy"
        >
          <el-input
            v-model="form.inviteBy"
            class="searchIpt"
            autocomplete="off"
            type="textarea"
            :rows="5"
            placeholder="任务描述"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="所属类别">
          <el-select
            v-model="form.type"
            placeholder="请选择所属类别"
            clearable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="(item, index) in typeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务是否需按顺序完成">
          <el-radio-group v-model="form.radio">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上架/下架时间">
          <el-date-picker
            size="mini"
            v-model="form.date"
            type="daterange"
            align="right"
            format="yyyy-MM-dd"
            clearable
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="适用用户类型">
          <el-select
            v-model="form.type"
            placeholder="请选择用户类型"
            clearable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="(item, index) in userOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="add">添加</el-button>
        <!-- <el-button size="mini" @click="clearFiled">重置</el-button> -->
      </span>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
      <div>任务配置</div>
      <div class="task">
        <el-form :model="taskForm" :rules="taskRules" ref="form">
          <el-form-item
            :label-width="formLabelWidth"
            prop="userId"
            v-for="(item, index) in form.lang"
            :key="index"
            :label="`${FINDLANGARR(item)}名称`"
          >
            <el-input v-model="form[item]" class="searchIpt"></el-input>
          </el-form-item>

          <el-form-item
            :label-width="formLabelWidth"
            prop="inviteBy"
            v-for="(item, index) in form.lang"
            :key="index"
            :label="`${FINDLANGARR(item)}任务说明`"
          >
            <el-input v-model="form[item]" class="searchIpt"></el-input>
          </el-form-item>
          <el-form-item label="任务内容">
            <el-select
              v-model="form.type"
              placeholder="请选择任务内容"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in taskContentOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="addTask">
              <el-button size="mini" type="primary" @click="handleAddTask"
                >添加任务</el-button
              >
              <el-button size="mini" type="primary" @click="handleDelTask"
                >删除任务</el-button
              >
            </div>
            <div class="flex" v-for="item in addTaskArr" :key="item">
              <el-select
                v-model="form.type"
                placeholder="请选择任务内容"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in taskContentOptions1"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="form.type"
                placeholder="请选择任务内容"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in taskContentOptions2"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="form.coin"
                placeholder="请选择币种"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in coinOptions2"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-model="form.amount"
                class="searchIpt"
                placeholder="数量"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            :label-width="formLabelWidth"
            prop="userId"
            label="奖励类型"
          >
            <div class="flex">
              <el-select
                v-model="form.type"
                placeholder="请选择奖励金"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in rewardOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
              <el-input
                v-model="form.amount"
                class="searchIpt"
                placeholder="数量"
              ></el-input>
              <el-input
                v-model="form.amount"
                class="searchIpt"
                placeholder="天数"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            :label-width="formLabelWidth"
            prop="userId"
            label="最大奖励数量"
          >
            <el-input v-model="form.amount" class="searchIpt"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { LANGARR, FINDLANGARR } from '../../constants'
export default {
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        inviteBy: '',
        userId: '',
        rate: '',
        remark: '',
        lang: [],
        coin: 0,
      },
      taskForm: {
        inviteBy: '',
        userId: '',
        rate: '',
        remark: '',
        lang: [],
      },
      langArr: LANGARR,
      formLabelWidth: 'auto',
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        inviteBy: [
          { required: true, message: '请输入合伙人UID', trigger: 'blur' },
        ],
        rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        ],
      },
      taskRules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        inviteBy: [
          { required: true, message: '请输入合伙人UID', trigger: 'blur' },
        ],
        rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        ],
      },
      currentLang: '',
      typeOptions: [
        {
          label: '普通账户',
          value: 0,
        },
        {
          label: '量化账户',
          value: 1,
        },
        {
          label: '风险保证金账户',
          value: 2,
        },
      ],
      userOptions: [
        {
          label: '普通账户',
          value: 0,
        },
        {
          label: '量化账户',
          value: 1,
        },
        {
          label: '风险保证金账户',
          value: 2,
        },
      ],
      rewardOptions: [
        {
          label: '奖励金-10USDT',
          value: 0,
        },
      ],
      taskContentOptions: [
        {
          label: 'AND',
          value: 0,
        },
        {
          label: 'OR',
          value: 1,
        },
      ],
      taskContentOptions1: [
        {
          label: '入金充值',
          value: 0,
        },
        {
          label: '永续合约交易体验',
          value: 1,
        },
      ],
      taskContentOptions2: [
        {
          label: '单次金额达成',
          value: 0,
        },
        {
          label: '累计金额达成',
          value: 1,
        },
      ],
      coinOptions2: [
        {
          label: 'USDT',
          value: 0,
        },
      ],
      addTaskArr: 1,
    }
  },
  methods: {
    ...mapActions('partnerList', ['addPartner', 'getUserData']),
    FINDLANGARR,
    changeCurrentLang(value) {
      this.currentLang = value
    },
    setCurrentLang(item) {
      this.currentLang = this.form.lang[0]
    },
    handleAddTask() {
      this.addTaskArr++
    },
    handleDelTask() {
      this.addTaskArr == 0 ? (his.addTaskArr = 0) : this.addTaskArr--
    },
    openDialog() {
      this.moveDialogVisible = true
    },

    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addPartner(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.$emit('refresh')
              this.clear()
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}
.task {
  border: 1px solid #000;
  padding: 12px;
}

.flex {
  display: flex;
  gap: 12px;
  align-items: center;
}
.addTask {
}
</style>
